import { Directive, input, TemplateRef } from '@angular/core';

@Directive({
    selector: '[uiTableTemplate]',
    standalone: true,
})
export class UiTableTemplateDirective {
    name = input.required<string>();

    constructor(public readonly templateRef: TemplateRef<any>) {}
}
